import React from "react";
import styles from "./PopularRequests.module.css";

const requests = [
    { id: 1, title: "Airport Pickup Arrangement" },
    { id: 2, title: "Luxury Dinner Reservations" },
    { id: 3, title: "Personal Shopping Assistance" },
    { id: 4, title: "Travel Itinerary Planning" },
    { id: 5, title: "Errand Pickup & Delivery" },
    { id: 6, title: "Corporate Event Support" },
];

function PopularRequest() {
    return (
        <section className={styles.section}>

            <h2>Popular Concierge Requests</h2>

            <div className={styles.grid}>
                {requests.map((request) => (
                    <div key={request.id} className={styles.item}>
                        <span>{request.title}</span>
                        <span className={styles.arrow}>→</span>
                        {/* <img className={styles.arrow} src="./images/arrow.svg" alt="right arrow" /> */}
                    </div>
                ))}
            </div>

        </section>
    );
}

export default PopularRequest;